"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryUtils = void 0;
const getNumber = (query, param) => {
    const value = query === null || query === void 0 ? void 0 : query[param];
    if (value === undefined || value === null)
        return undefined;
    return parseInt(value);
};
exports.queryUtils = {
    getNumber,
};
//# sourceMappingURL=queryUtils.js.map